import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {GlobalMessageActions, GlobalMessageType, isNotUndefined, LoggerService, Translatable} from '@spartacus/core';
import {Observable, of} from 'rxjs';
import {filter, map, switchMap} from 'rxjs/operators';

@Injectable()
export class CartVoucherGlobalMessageEffect {
  protected logger = inject(LoggerService);

  constructor(private actions$: Actions) {}

  removePromoMessage$: Observable<GlobalMessageActions.RemoveMessage> = createEffect(() =>
    this.actions$.pipe(
      ofType(GlobalMessageActions.ADD_MESSAGE),
      map((action) => (action as GlobalMessageActions.AddMessage).payload),
      switchMap((message) =>
        of(message.text).pipe(
          filter((text: Translatable) => text.key === 'voucher.applyVoucherSuccess'),
          map(() => {
            return new GlobalMessageActions.RemoveMessage({
              type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
              index: 0,
            });
          }),
          filter(isNotUndefined)
        )
      )
    )
  );
}
